/**
 * Created by JackCui on 2021/4/13
 */

export const CUSTOM = 'custom__'
